<template>
  <div id="contenedor-eliminar-oficio-autorizacion-detalle">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Recurso </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar el recurso? </span>
        <v-divider></v-divider>
        <v-row>
          <span class="font-weight-bold">
            {{oficioAutorizacionDetalleEliminar.clavePresupuestal}}
          </span>
        </v-row>
        <v-row v-if="oficioAutorizacionDetalleEliminar.obraSolicitada">
          <span> <cortar-textos
          :texto="oficioAutorizacionDetalleEliminar.obraSolicitada.meta || ''">
          </cortar-textos>
          </span>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarOficioDetalle"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import CortarTextos from '@/components/CortarTextos.vue';
import CustomButton from '@/components/buttons/Button.vue';
import MixOficioAutorizacionDetalle from './mixOficioAutorizacionDetalle';

export default {
  name: 'EliminarOficioAutorizacionDetalle',
  mixins: [MixOficioAutorizacionDetalle],
  props: {
    oficioAutorizacionDetalleEliminar: Object,
  },
  components: {
    CortarTextos,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
